import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ArrowLeft } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="container mx-auto px-4 py-8 max-w-4xl">
        <Link to="/">
          <Button variant="ghost" className="mb-6">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Voltar
          </Button>
        </Link>

        <h1 className="text-3xl font-bold font-outfit mb-8">Termos e Condições</h1>
        
        <div className="prose prose-lg dark:prose-invert max-w-none space-y-8">
          <p className="text-muted-foreground">
            Última atualização: Janeiro de 2026
          </p>

          <section>
            <h2 className="text-xl font-semibold mt-8 mb-4">1. Aceitação dos Termos</h2>
            <p>
              Ao aceder e utilizar a plataforma PasseioPerfeito ("Plataforma"), concorda com os presentes Termos e Condições. 
              Se não concordar com estes termos, não deve utilizar os nossos serviços.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mt-8 mb-4">2. Descrição do Serviço</h2>
            <p>
              O PasseioPerfeito é uma plataforma online que conecta donos de animais de estimação ("Clientes") 
              com prestadores de serviços de pet sitting e passeio de cães ("Prestadores").
            </p>
            <p className="mt-4">
              <strong>A plataforma funciona exclusivamente como intermediário</strong>, facilitando o contacto 
              entre Clientes e Prestadores. Não somos uma empresa de pet sitting nem empregamos os Prestadores.
            </p>
          </section>

          <section className="bg-destructive/10 border border-destructive/20 rounded-lg p-6 my-8">
            <h2 className="text-xl font-semibold mb-4 text-destructive">3. Isenção de Responsabilidade - IMPORTANTE</h2>
            <p className="font-medium">
              O PasseioPerfeito é <strong>apenas uma plataforma de conexão</strong> entre clientes e prestadores.
            </p>
            <ul className="list-disc pl-6 mt-4 space-y-2">
              <li>
                <strong>Não somos responsáveis</strong> por qualquer ação, serviço, dano, acidente, lesão, perda 
                ou incumprimento por parte dos pet sitters/passeadores.
              </li>
              <li>
                <strong>O contrato é direto</strong> entre o Cliente é o Prestador. O PasseioPerfeito não é 
                parte de qualquer acordo de serviço celebrado entre as partes.
              </li>
              <li>
                <strong>Não garantimos</strong> a qualidade, segurança, adequação ou legalidade dos serviços 
                prestados pelos Prestadores.
              </li>
              <li>
                <strong>Não verificamos</strong> de forma independente todas as informações fornecidas pelos 
                utilizadores, incluindo qualificações, experiência ou antecedentes dos Prestadores.
              </li>
              <li>
                <strong>Recomendamos fortemente</strong> que os Clientes realizem as suas próprias verificações 
                e conheçam pessoalmente o Prestador antes de lhe confiar o seu animal.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mt-8 mb-4">4. Responsabilidades do Cliente</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Fornecer informações verdadeiras e atualizadas sobre si e sobre os seus animais.</li>
              <li>Informar o Prestador sobre quaisquer necessidades especiais, condições médicas ou comportamentais do animal.</li>
              <li>Garantir que os seus animais têm as vacinas em dia e estão em boas condições de saúde.</li>
              <li>Efetuar os pagamentos acordados diretamente com o Prestador.</li>
              <li>Respeitar os termos acordados com o Prestador.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mt-8 mb-4">5. Responsabilidades do Prestador</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Fornecer informações verdadeiras sobre a sua experiência e serviços.</li>
              <li>Prestar os serviços acordados com o devido cuidado e diligência.</li>
              <li>Informar imediatamente o Cliente sobre qualquer incidente ou problema.</li>
              <li>Manter um seguro de responsabilidade civil adequado (recomendado).</li>
              <li>Cumprir todas as leis e regulamentos aplicáveis.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mt-8 mb-4">6. Sistema de Avaliações</h2>
            <p>
              As avaliações e comentários são baseados nas experiências dos utilizadores. O PasseioPerfeito 
              não verifica a veracidade das avaliações, embora se reserve o direito de remover conteúdo 
              inapropriado, falso ou que viole estes termos.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mt-8 mb-4">7. Pagamentos</h2>
            <p>
              Os pagamentos entre Clientes e Prestadores são efetuados diretamente entre as partes ou através 
              dos métodos disponibilizados na plataforma (cartão, MB Way). O PasseioPerfeito pode cobrar taxas 
              de subscrição aos Prestadores pelos serviços premium.
            </p>
            <p className="mt-4">
              <strong>Política de Reembolso:</strong> Disputas de pagamento devem ser resolvidas diretamente 
              entre Cliente e Prestador. O PasseioPerfeito não se responsabiliza por reembolsos de serviços.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mt-8 mb-4">8. Cancelamentos</h2>
            <p>
              As políticas de cancelamento são definidas individualmente por cada Prestador. Recomendamos 
              que acordem os termos de cancelamento antes de confirmar qualquer reserva.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mt-8 mb-4">9. Privacidade e Dados Pessoais</h2>
            <p>
              Os dados pessoais são tratados de acordo com a nossa Política de Privacidade é o Regulamento 
              Geral de Proteção de Dados (RGPD). Ao utilizar a plataforma, consente a recolha e tratamento 
              dos seus dados conforme descrito na referida política.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mt-8 mb-4">10. Propriedade Intelectual</h2>
            <p>
              Todo o conteúdo da plataforma, incluindo logotipos, textos, imagens e software, é propriedade 
              do PasseioPerfeito ou dos seus licenciadores e está protegido por direitos de autor.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mt-8 mb-4">11. Modificações aos Termos</h2>
            <p>
              Reservamo-nos o direito de modificar estes Termos e Condições a qualquer momento. As alterações 
              entram em vigor após publicação na plataforma. O uso continuado após as alterações constitui 
              aceitação dos novos termos.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mt-8 mb-4">12. Lei Aplicável e Jurisdição</h2>
            <p>
              Estes Termos e Condições são regidos pela lei portuguesa. Qualquer litígio será submetido 
              aos tribunais competentes de Portugal.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mt-8 mb-4">13. Contacto</h2>
            <p>
              Para questões sobre estes Termos e Condições, contacte-nos através de:
            </p>
            <ul className="list-none mt-4 space-y-1">
              <li>Email: suporte@passeioperfeito.pt</li>
              <li>Telefone: 928 314 198</li>
            </ul>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}
